const first_name = 60;
const last_name = 60;
const city = 32;
const street = 256;
const street_unit = 12;
const street_number = 255;
const state = 90;
const zipcode = 10;
const district = 60;
const street_and_number = 80;
const detailed_address = 114;
const floor_unit = 10;

export const MAX_LENGTH_PROFILE = {
  first_name,
  last_name,
  street,
  street_unit,
  street_number,
  state,
  zipcode,
  district,
  street_and_number,
  detailed_address,
  city: 40,
  floor_unit: 32,
}

export const MAX_LENGTH_BILLING = {
  city,
  street,
  street_unit,
  state,
  district,
  street_and_number,
  detailed_address,
  floor_unit,
  street_number: 12,
  zipcode: 40,
}

export const MAX_LENGTH_ORDER = {
  first_name,
  last_name,
  city,
  street_number,
  state,
  zipcode,
  floor_unit,
  street: 100,
  street_unit: 10,
}

export const MAX_LENGTH_REGISTER = {
  firstName: first_name,
  lastName: last_name,
  city,
  email: 256,
  confirmEmail: 256,
}



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/constants/max_length.js